/**
 * The loading and failed states inside a Scores section card (Scores UX spec
 * v1.0 sections 1.9 and 2.4), the same markup on the All feed, Your teams and
 * the league view. Loading is three skeleton rows in the row's own anatomy;
 * failed is the failed line and a compact Try again, inside the card.
 */
import { Button, cn } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  SCORES_FAILED_LINE,
  SCORES_LOADING_LABEL,
  TRY_AGAIN_LABEL,
} from "./leagueSelectorContract";
import { ScoreRowSkeleton } from "./ScoreRow";

export const ScoresSectionLoading = (props: {
  testId: string;
  rows?: number;
}): ReactNode => (
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label={SCORES_LOADING_LABEL}
    data-testid={props.testId}
  >
    {Array.from({ length: props.rows ?? 3 }, (_, index) => (
      <ScoreRowSkeleton key={index} />
    ))}
  </div>
);

export const ScoresSectionFailed = (props: {
  testId: string;
  onRetry: () => void;
  /** False in a card with no header above, where a top hairline would
   *  double the card's own border. */
  hasDivider?: boolean;
}): ReactNode => (
  <div
    className={cn(
      "flex flex-col items-start gap-3 px-score-row-inset py-3",
      props.hasDivider === false ? undefined : "border-t border-hairline",
    )}
    data-testid={props.testId}
  >
    <p className="text-body text-error">{SCORES_FAILED_LINE}</p>
    <Button variant="secondary" size="sm" onClick={props.onRetry}>
      {TRY_AGAIN_LABEL}
    </Button>
  </div>
);
